export default __webpack_public_path__ + "static/media/275.fdab40f1.jpg";